import type {Placement} from '@react-aria/overlays';

import type {
    TooltipPosition,
    ExtendedTooltipPosition,
} from '../../../types/propTypes';

const positionMap: Record<
    TooltipPosition | ExtendedTooltipPosition,
    Placement
> = {
    bottom: 'bottom',
    bottomEnd: 'bottom end',
    bottomLeft: 'bottom left',
    bottomRight: 'bottom right',
    bottomStart: 'bottom start',
    bottomCenter: 'bottom',
    endBottom: 'end bottom',
    left: 'left',
    right: 'right',
    top: 'top',
    topEnd: 'top end',
    topLeft: 'top left',
    topRight: 'top right',
    topStart: 'top start',
    topCenter: 'top',
};

/**
 * The helper function maps the internal TooltipPosition to Placement which is used by react-aria.
 * We have introduced that to avoid breaking changes for the Tooltip component.
 * see https://github.com/adobe/react-spectrum/blob/main/packages/%40react-types/overlays/src/index.d.ts
 * @param position - The position of the tooltip
 * @returns The mapped placement for react-aria
 */
export const mapTooltipPosition = (
    position: TooltipPosition | ExtendedTooltipPosition,
): Placement => {
    return positionMap[position] || 'top';
};
